import { SystemSettingsResponse, UpdateSystemSettingPayload } from '@/types';
import { apiSlice } from './apiSlice';

export const systemSettingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ GET /system
    getSystemSettings: builder.query<SystemSettingsResponse, void>({
      query: () => ({
        url: '/system',
        method: 'GET',
        params: {
          ts: Date.now(),
        },
      }),
      providesTags: ['SystemSettings'],
    }),

    // ✅ PATCH /system/settings
    updateSystemSettings: builder.mutation<
      { message: string },
      { data: UpdateSystemSettingPayload[] }
    >({
      query: (body) => ({
        url: '/system/settings',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['SystemSettings'],
    }),
  }),
});

export const { useGetSystemSettingsQuery, useUpdateSystemSettingsMutation } = systemSettingsApi;
